import { workspacePreviewSurface } from "./workspacePreviewSurface";

export function replyFileBadge(path: string): { label: string; tone: string } {
  const extension = path.split("/").at(-1)?.split(".").slice(1).at(-1)?.toUpperCase();
  return {
    label: extension && extension.length <= 5 ? extension : "FILE",
    tone: workspacePreviewSurface(path),
  };
}

/** Reuse the panel's format classification for deliverable cards. */
export function replyFileLabel(path: string): string {
  const surface = workspacePreviewSurface(path);
  const extension = path.split("/").at(-1)?.split(".").slice(1).at(-1)?.toUpperCase();
  const category = {
    pdf: "Document",
    document: "Document",
    spreadsheet: "Spreadsheet",
    presentation: "Presentation",
    html: "Page",
    image: "Image",
    video: "Video",
    audio: "Audio",
    archive: "Archive",
    text: "File",
  }[surface];
  return extension ? `${category} · ${extension}` : category;
}
